import React, { useState, useRef } from 'react';
import { InputGroup, FormControl, Button, DropdownButton, Dropdown } from 'react-bootstrap';
import { getSubCategoryOptions, getIndustryOptions } from '../../../configs/dropdownOptions';

export default function FilterOptions(props) {
    const [activeSubCategory, setActiveSubCategory] = useState('');
    const [activeIndustry, setActiveIndustry] = useState('');
    const [activeCategory, setActiveCategory] = useState('Threats');

    const inputUI = useRef(null);
    const inputCheckBox = useRef(null);

    const onClearClick = () => {
        props.clearCallback();
        inputUI.current.value = '';
        setActiveSubCategory('')
        setActiveIndustry('')
    }

    const onCheckBoxChange = (e) => {
        props.exactMatchcallBack(e.target.checked)
    }

    return (
        <div className="d-flex">
            {/* 1. Search Field */}
            <InputGroup className="mb-3" size='sm'>
                <InputGroup.Prepend>
                    <InputGroup.Checkbox defaultChecked aria-label="Checkbox for following text input" onChange={onCheckBoxChange} />
                    <InputGroup.Text>Exact Match</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    ref={inputUI}
                    defaultValue={props.initialSearch}
                    placeholder="Recipient's username"
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    onChange={e => props.setSeachTerm(e.target.value)}
                    onKeyPress={e => { if (e.key === 'Enter') props.onSearchSubmit() }}
                />
                <InputGroup.Append>
                    <Button variant="outline-secondary" onClick={props.onSearchSubmit} >Search</Button>
                </InputGroup.Append>
            </InputGroup>

            {/* 2. Dropdown to change the category */}
            <Dropdown className="ml-2">
                <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic" size="sm">
                    {activeCategory}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Breaches'); setActiveCategory('Breaches') }}>Breaches</Dropdown.Item>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Stories'); setActiveCategory('Stories') }}>Stories</Dropdown.Item>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Threats'); setActiveCategory('Threats') }}>Threats</Dropdown.Item>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Actors'); setActiveCategory('Actors') }}>Actors</Dropdown.Item>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Solutions'); setActiveCategory('Solutions') }}>Solutions</Dropdown.Item>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Companies'); setActiveCategory('Companies') }}>Companies</Dropdown.Item>
                    <Dropdown.Item onClick={() => { props.mainCategoryCallback('Experts'); setActiveCategory('Experts') }}>Experts</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            {/* 3. Dropdown to change the Sub Category */}
            <Dropdown className="ml-2">
                <Dropdown.Toggle
                    size="sm"
                    variant="outline-secondary"
                    id="dropdown-basic"
                >
                    {(activeSubCategory === '' || activeSubCategory === 'Other') ? "Sub-Category" : activeSubCategory.substr(0, 15)}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {getSubCategoryOptions().map(el => <Dropdown.Item onClick={() => { props.subCategoryCallback(el); setActiveSubCategory(el) }} key={el} >{el}</Dropdown.Item>)}
                </Dropdown.Menu>
            </Dropdown>

            {/* 4. Dropdown to change the Industry */}
            <Dropdown className="ml-2">
                <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic" size="sm">
                    {(activeIndustry === '' || activeIndustry === 'Other') ? "Industry" : activeIndustry.substr(0, 15)}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {getIndustryOptions().map(el => <Dropdown.Item onClick={() => { props.industryCallback(el); setActiveIndustry(el) }} key={el} >{el}</Dropdown.Item>)}
                </Dropdown.Menu>
            </Dropdown>

            {/* Clear Filter Button to res*/}
            <Button className="ml-2 clear-button" variant="outline-secondary" onClick={onClearClick}>Clear</Button>
        </div>
    )
}
